module.exports = __webpack_public_path__ + "static/media/10018.3c2bb916.jpg";